import React from 'react'
import { Search, LocationPin } from '@mui/icons-material'
import { Input } from '@mui/material'
import { Genre } from '../../Api/Lirari/Types/genre'
import { Offering } from '../../Api/Lirari/Types/offering'
import OfferingsModal from './offeringsModal'
import GenresModal from './genresModal'

const SearchComponents = ({
  genres,
  offerings,
  selectedGenres,
  selectedOfferings,
  searchInput,
  setSelectedGenres,
  setSelectedOfferings,
  setIsLocationModalOpen: setIsLocationOpen,
  setSearchInput,
}: {
  genres: Genre[]
  offerings: Offering[]
  selectedGenres: Genre[]
  selectedOfferings: Offering[]
  searchInput: string
  setSelectedGenres: (value: Genre[]) => void
  setSelectedOfferings: (value: Offering[]) => void
  setIsLocationModalOpen: (value: boolean) => void
  setSearchInput: (value: string) => void
}) => {
  const [filteredGenres, setFilteredGenres] = React.useState<Genre[]>(genres)
  const [offeringsModalOpen, setOfferingsModalOpen] = React.useState(false)
  const [genresModalOpen, setGenresModalOpen] = React.useState(false)

  const toggleGenre = (genre: Genre) => {
    setSelectedGenres(
      selectedGenres.includes(genre)
        ? selectedGenres.filter((prevGenre) => prevGenre != genre)
        : [...selectedGenres, genre],
    )
  }

  const toggleOffering = (offering: Offering) => {
    setSelectedOfferings(
      selectedOfferings.includes(offering)
        ? selectedOfferings.filter((item) => item != offering)
        : [...selectedOfferings, offering],
    )
  }

  const filterGenres = (input: string) => {
    const lowerCasedInput = input.toLowerCase()
    const filtered = genres.filter((genre) => genre.name.toLowerCase().includes(lowerCasedInput))
    setFilteredGenres(filtered)
  }

  return (
    // Desktop View Here, Mobile Below
    <div className="lg:w-1/4 w-full">
      <div className="lg:flex hidden px-[22px] py-[30px] h-full space-x-8 w-full">
        <div className="flex flex-col w-full space-y-8">
          <div
            className="flex items-center space-x-3 rounded-lg w-full px-3 py-4 backdrop-blur-sm bg-gradient-to-b from-[#494949]/80 to-[#242424]/80"
            onClick={() => setIsLocationOpen(true)}
          >
            <LocationPin sx={{ width: 32, height: 32 }} />
            <p className="text-lg">Select Location</p>
          </div>
          <div className="flex items-center space-x-3 rounded-lg w-full px-3 py-4 backdrop-blur-sm bg-gradient-to-b from-[#494949]/80 to-[#242424]/80">
            <Search sx={{ width: 32, height: 32 }} />
            <Input
              className="text-lg w-full"
              placeholder="Instrument/Name/SubGenre"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
          </div>
          <div className="flex flex-col items-start rounded-lg w-full min-h-[300px] max-h-[340px] px-3.5 mb-0 mx-4 lg:mx-0 pb-[4vh] backdrop-blur-sm bg-gradient-to-b from-[#494949]/80 to-[#242424]/80">
            <p className="py-[5px] title-small">Offerings</p>
            <div className="flex flex-wrap gap-2 overflow-y-auto">
              {offerings.map((offering, index) => (
                <p
                  key={index}
                  onClick={() => toggleOffering(offering)}
                  className={`flex gap-2.5 mt-0 py-2 px-5 rounded-3xl cursor-pointer ${
                    selectedOfferings.includes(offering) ? 'bg-black' : 'bg-[#5E5E5E]'
                  }`}
                >
                  {offering.name}
                </p>
              ))}
            </div>
          </div>
          <div className="flex flex-col items-start rounded-lg w-full min-h-[300px] max-h-[340px] px-3.5 mb-0 mx-4 lg:mx-0 pb-[4vh] backdrop-blur-sm bg-gradient-to-b from-[#494949]/80 to-[#242424]/80">
            <p className="py-[5px] title-small">Genres</p>
            <Input
              className="text-lg w-full mb-2"
              placeholder="Filter Genres"
              onChange={(e) => filterGenres(e.target.value)}
            />
            <div className="flex flex-wrap gap-2 overflow-y-auto">
              {[
                ...selectedGenres,
                ...filteredGenres.filter(
                  (filteredGenre) => !selectedGenres.some((selectedGenre) => selectedGenre.id == filteredGenre.id),
                ),
              ].map((genre) => (
                <p
                  key={genre.id}
                  onClick={() => toggleGenre(genre)}
                  className={`flex gap-2.5 mt-0 py-2 px-5 rounded-3xl cursor-pointer ${
                    selectedGenres.includes(genre) ? 'bg-black' : 'bg-[#5E5E5E]'
                  }`}
                >
                  {genre.name}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* Mobile view here */}
      <div className="lg:hidden flex flex-col px-2 py-[30px] w-full">
        <div className="flex flex-row w-full gap-2">
          <div
            className="flex items-center rounded-lg px-3 py-4 backdrop-blur-sm bg-gradient-to-b from-[#494949]/80 to-[#242424]/80"
            onClick={() => setIsLocationOpen(true)}
          >
            <LocationPin sx={{ width: 32, height: 32 }} />
          </div>
          <div className="flex items-center w-full rounded-lg px-3 py-4 backdrop-blur-sm bg-gradient-to-b from-[#494949]/80 to-[#242424]/80">
            <Search sx={{ width: 32, height: 32 }} />
            <Input
              className="text-lg w-full"
              placeholder="Instrument/Name/SubGenre"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
          </div>
        </div>
        <div className="flex flex-row w-full gap-2">
          <div
            className="gap-2 mt-0 py-2 px-5 w-1/2 rounded-3xl z-10 bg-[#5E5E5E]"
            onClick={() => setOfferingsModalOpen(true)}
          >
            <div className="flex flex-col items-center py-[5px] title-small text-white">Offerings</div>
          </div>
          <div
            className="gap-2 mt-0 py-2 px-5 w-1/2 rounded-3xl z-10 bg-[#5E5E5E]"
            onClick={() => setGenresModalOpen(true)}
          >
            <div className="flex flex-col items-center py-[5px] title-small text-white">Genres</div>
          </div>
        </div>
      </div>
      {offeringsModalOpen ? (
        <OfferingsModal
          setOfferings={setSelectedOfferings}
          setOfferingsModalOpen={setOfferingsModalOpen}
        ></OfferingsModal>
      ) : (
        <></>
      )}
      {genresModalOpen ? (
        <GenresModal setGenres={setSelectedGenres} setGenresModalOpen={setGenresModalOpen}></GenresModal>
      ) : (
        <></>
      )}
    </div>
  )
}

export default SearchComponents
